import { render } from "./myfooter.vue?vue&type=template&id=a0d0af2c&scoped=true"
import script from "./myfooter.vue?vue&type=script&lang=js"
export * from "./myfooter.vue?vue&type=script&lang=js"

import "./myfooter.vue?vue&type=style&index=0&id=a0d0af2c&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d0af2c"]])

export default __exports__